export const BidAccepted = {
    Titles: {
        jobAwarded: `Job Awarded`,
        providerEnroute: `Provider Enroute`,
        providerArrived: `Provider Arrived`
    },
    SubTitles: {
        providerStatus: 'Provider Status'
    },
    JobStatus: {
        accepted: 'Accepted',
        onMyWay: 'On My Way',
        arrived: 'Arrived'
    },
    Buttons: {
        Cancel: {
            label: 'Cancel'
        }
    },
    Text: {
        complimentsReceived: 'Compliments received:',
        price: 'Price: $',
        jobTime: 'Job Time'
    }
}



// WEBPACK FOOTER //
// ./src/localization/BidAccepted.ts